import {Component, Input, OnInit} from '@angular/core';
import {User} from "../../models/user.model";
import {AuthService} from "../../services/auth.service";
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'kis-username-menu',
  templateUrl: './username-menu.component.html',
  styleUrls: ['./username-menu.component.scss']
})
export class UsernameMenuComponent implements OnInit {

  /** User object */
  @Input()
  user: User;

  /** Permission check */
  @Input()
  canSeeConfig: boolean;

  constructor(public authService: AuthService, public storage: StorageService) { }

  ngOnInit(): void {
  }

}
